const INITIAL_STATE = {
  todos: [],
  carregando: false,
  erro: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case "OBTER_TIPOS_CONTRATOS":
      return {...state, carregando: false, todos: action.tipoContrato};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/TipoContratoReducer.js